import React from "react";
import { VStack, Heading, Box } from "@chakra-ui/react";
import JdGrid from "./JdGrid";
import { useLocation } from "react-router-dom";

const ConfigureJdWeights = () => {
  const { state } = useLocation();
  const { serializedRowData, run_id, jobProfileName, matchingJds, requiredJobTitle } = state;
  return (
    <VStack>
      <Heading>Configure JD weights</Heading>
      <br />
      <Box borderWidth="3px" borderRadius="lg" p="10">
        <JdGrid
          serializedRowData={serializedRowData}
          run_id={run_id}
          jobProfileName={jobProfileName}
          matchingJds={matchingJds}
          requiredJobTitle={requiredJobTitle}
        />
      </Box>
    </VStack>
  );
};

export default ConfigureJdWeights;
